import { DirectionsSection, ParkingSection, ShuttleSection, Sidebar } from '@uofu-uss-gis/ui-react';
import UParkEventParkingSection from './UParkEventParkingSection';

function UParkSidebar() {
  return (
    <Sidebar>
      <DirectionsSection />
      <ParkingSection />
      <ShuttleSection />
      <UParkEventParkingSection />
    </Sidebar>
  );
}

export default UParkSidebar;
